import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-hidden", "aria-expanded"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "inner" }

import { useLocationStore, usePortStore, useRoutesStore } from '@components/stores';
import {
  MapPort, MapLocation, GoogleMapsRoute, InteractiveMapPanelViewModel,
} from '@components/types';
import vClickOutside from '@venegrad/vue3-click-outside';
import { ref, watch, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { Icon, PanelViewModal } from '../..';
import { SMALL_DESKTOP_VIEWPORT_WIDTH } from '../../config';
import { routeInformationUrl } from '../../envVariables';


export default /*@__PURE__*/_defineComponent({
  __name: 'MoreInfoPanel',
  props: {
    isOpen: { type: Boolean },
    closeCallback: { type: Function },
    port: {},
    destination: {},
    route: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const isSmallScreenWidth = window.innerWidth <= SMALL_DESKTOP_VIEWPORT_WIDTH;
const locationStore = useLocationStore();
const portStore = usePortStore();
const routeStore = useRoutesStore();

const isModalExpand = ref(false);
const isLoading = ref(false);

const initialViewState = {
  title: '',
  description: '',
  soundbiteUrl: undefined,
  activities: undefined,
  address: undefined,
  addressTitle: undefined,
  linkText: '',
  linkUrl: '',
  routesServed: undefined,
};

const viewState = ref<InteractiveMapPanelViewModel>(initialViewState);

const handleClickOutside = () => {
  if (isSmallScreenWidth) {
    props.closeCallback();
  }
  isModalExpand.value = false;
};

const toggleModal = () => {
  isModalExpand.value = !isModalExpand.value;
};

const updateLocation = (location) => {
  viewState.value = {
    ...initialViewState,
    title: location.name,
    description: location.description ?? '',
    soundbiteUrl: location.soundbiteUrl,
    activities: location.activities,
    linkText: t('Discover destination', [location.name]),
    linkUrl: location.locationUrl,
    routesServed: locationStore.getLocationsServed,
  };
};

const updatePort = (port) => {
  viewState.value = {
    ...initialViewState,
    title: port.name ?? '',
    description: port.description ?? '',
    address: port.address,
    addressTitle: t('Port location'),
    linkText: t('Find out more'),
    linkUrl: port.portUrl,
    routesServed: portStore.getPortsServed,
  };
};

const updateRoute = (route) => {
  viewState.value = {
    ...initialViewState,
    title: t('Route info'),
    description: route.description ?? '',
    linkText: t('More route info and fares'),
    linkUrl: `${routeInformationUrl}/${route.routeCode}`,
    routesServed: routeStore.getRoutesServed ? [routeStore.getRoutesServed] : [],
  };
};

watchEffect(async () => {
  if (props.destination && props.destination.code) {
    await locationStore.requestLocationsServed(props.destination.code);
    if (locationStore.locationsServed) {
      updateLocation(locationStore.locationsServed);
    }
  } else if (props.port && props.port.portCode) {
    await portStore.requestPortsServed(props.port.portCode);
    if (portStore.portsServed) {
      updatePort(portStore.portsServed);
    }
  } else if (props.route && props.route.code) {
    await routeStore.requestRouteServed(props.route.code);
    if (routeStore.routeServed) {
      updateRoute(routeStore.routeServed);
    }
  }
});

watchEffect(() => {
  if (routeStore.routeServed) {
    updateRoute(routeStore.routeServed);
  }
});

watchEffect(() => {
  if (locationStore.locationsServed) {
    updateLocation(locationStore.locationsServed);
  }
});

watchEffect(() => {
  if (portStore.portsServed) {
    updatePort(portStore.portsServed);
  }
});

watchEffect(() => {
  isLoading.value = routeStore.isLoading || portStore.isLoading || locationStore.isLoading;
});

watch(() => props.isOpen, (isPanelOpen) => {
  if (isPanelOpen && isSmallScreenWidth) {
    document.querySelector('body')?.classList.add('exploreMapActive');
  } else if (!isPanelOpen && isSmallScreenWidth) {
    document.querySelector('body')?.classList.remove('exploreMapActive');
  }
});


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["moreInfoPanel", {panelActive: _ctx.isOpen, modalExpanded: isModalExpand.value}]),
    "aria-hidden": !_ctx.isOpen,
    "aria-expanded": _ctx.isOpen
  }, [
    _createElementVNode("button", {
      class: "overlayClose",
      "aria-label": _ctx.$t('Close overlay aria label'),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args)))
    }, [
      _createVNode(_unref(Icon), { "icon-name": "close" })
    ], 8, _hoisted_2),
    _createElementVNode("button", {
      class: _normalizeClass(["mobileExpandBtn", {expanded: isModalExpand.value}]),
      "aria-label": isModalExpand.value ? _ctx.$t('Collapse modal') : _ctx.$t('Expand modal'),
      onClick: toggleModal
    }, [
      _createVNode(_unref(Icon), { "icon-name": "expandIcon" })
    ], 10, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(PanelViewModal), {
        "view-modal": viewState.value,
        "is-loading": isLoading.value
      }, null, 8, ["view-modal", "is-loading"])
    ])
  ], 10, _hoisted_1)), [
    [_unref(vClickOutside), handleClickOutside]
  ])
}
}

})